module.exports = __webpack_public_path__ + "img/icon4@2x.616aee4d.png";